import React, { useState } from 'react'

import lotto649Img from './lotto-649-logo.png'
import lottoMaxImg from './lottomax-w.png'

export const Lotto649Logo = ({ height = 28, style = {} }) => (
  <img src={lotto649Img} alt="Lotto 6/49" style={{ height: `${height}px`, objectFit: 'contain', display: 'block', ...style }} />
)

export const LottoMaxLogo = ({ height = 28, style = {} }) => (
  <img src={lottoMaxImg} alt="Lotto Max" style={{ height: `${height}px`, objectFit: 'contain', display: 'block', ...style }} />
)

// 紧凑版矢量轮盘 Logo
export const RouletteLogo = ({ height = 28, style = {} }) => (
  <svg
    height={height}
    viewBox="0 0 135 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ height: `${height}px`, width: 'auto', display: 'block', ...style }}
  >
    <text x="0" y="26" fill="#FFFFFF" fontSize="22" fontWeight="900" fontFamily="Arial, sans-serif" fontStyle="italic">
      Roulette
    </text>
    <g transform="translate(85, 5)">
      <circle cx="20" cy="20" r="19" fill="#78350F" stroke="#F59E0B" strokeWidth="1.5"/>
      <circle cx="20" cy="20" r="16" fill="#1E293B"/>
      <circle cx="20" cy="20" r="13" fill="none" stroke="#EF4444" strokeWidth="5" strokeDasharray="5 5"/>
      <circle cx="20" cy="20" r="13" fill="none" stroke="#000000" strokeWidth="5" strokeDasharray="5 5" strokeDashoffset="5"/>
      <circle cx="20" cy="20" r="7" fill="#F59E0B"/>
      <circle cx="20" cy="20" r="3" fill="#FFFBEB"/>
    </g>
    <text x="2" y="75" fill="#38BDF8" fontSize="40" fontWeight="900" fontFamily="Arial, sans-serif">
      37
    </text>
    <text x="56" y="73" fill="#94A3B8" fontSize="16" fontWeight="bold" fontFamily="Arial, sans-serif">
      SLOTS
    </text>
  </svg>
)

// 三合一胶囊卡片（缩小 gap 与 padding）
export const CombinedLogo = ({ height = 28, style = {} }) => {
  const [hovered, setHovered] = useState(false)

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',                   // 缩小缝隙（由 16px 改为 8px）
        padding: '5px 12px',           // 缩小内边距（由 22px 改为 12px）
        backgroundColor: '#0d4385',
        borderRadius: '30px',
        boxShadow: hovered
          ? '0 4px 12px rgba(13, 67, 133, 0.45)'
          : '0 2px 8px rgba(0, 0, 0, 0.2)',
        transform: hovered ? 'scale(1.03)' : 'scale(1)',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        boxSizing: 'border-box',
        maxWidth: '100%',
        ...style
      }}
    >
      <Lotto649Logo height={height} />
      <div style={{ width: '1px', height: `${height * 0.55}px`, backgroundColor: 'rgba(255, 255, 255, 0.3)' }} />
      <LottoMaxLogo height={height} />
      <div style={{ width: '1px', height: `${height * 0.55}px`, backgroundColor: 'rgba(255, 255, 255, 0.3)' }} />
      <RouletteLogo height={height} />
    </div>
  )
}